let host = 'https://xiangjunkeji.cn';
//let host = 'http://127.0.0.1:5389'
let apiList = {
    register: host + '/CM-API/memberApi/register',
    sendCodeToPhone: host + '/CM-API/memberApi/sendCodeToPhone',
    clientLogin: host + '/CM-API/memberApi/clientLogin',
    updatePassword: host + '/CM-API/memberApi/updatePassword',
    phoneCodeLogin: host + '/CM-API/memberApi/phoneCodeLogin',
    forgetAndUpdatePassword: host + '/CM-API/memberApi/forgetAndUpdatePassword',
    sendCodeToEmail: host + '/CM-API/memberApi/sendCodeToEmail',
    emailCodeLogin: host + '/CM-API/memberApi/emailCodeLogin',
    addTemplateInfo: host + '/CM-API/contactTemplateApi/addTemplateInfo',
    getTemplateList: host + '/CM-API/contactTemplateApi/getTemplateList',
    getTemplateDetails: host + '/CM-API/contactTemplateApi/getTemplateDetails',
    addContactInfo: host + '/CM-API/contactApi/addContactInfo',
    getContactList: host + '/CM-API/contactApi/getContactList',
    sendContact: host + '/CM-API/contactApi/sendContact',
    saveStampInfo: host + '/CM-API/stampApi/saveStampInfo',
    getStampList: host + '/CM-API/stampApi/getStampList',
    logout: host + '/CM-API/memberApi/logout',
    checkIdCardEnd: host + '/CM-API/memberApi/checkIdCardEnd',
    getMakeSale: host + '/CM-API/signatureApi/getMakeSale',
    cancelMember: host + '/CM-API/memberApi/cancelMember',
    memberAuthor: host + '/CM-API/memberApi/memberAuthor',
    companyAuthor: host + '/CM-API/memberApi/companyAuthor',
    getContactDetails: host + '/CM-API/contactApi/getContactDetails',
    getStatistics: host + '/CM-API/contactApi/getStatistics',
    getMemberInfo: host + '/CM-API/memberApi/getMemberInfo',
    getCertList: host + '/CM-API/certApi/getCertList',
    addOrderInfo: host + '/CM-API/orderApi/addOrderInfo',
    getOrderList: host + '/CM-API/orderApi/getOrderList',
    updateContact: host + '/CM-API/contactApi/updateContact',
    getNewsMouleList: host + '/CM-API/NewsApi/getNewsMouleList',
    getNewsListById: host + '/CM-API/NewsApi/getNewsListById',
    getdetailsAndBeforNext: host + '/CM-API/NewsApi/getdetailsAndBeforNext',
    getNews: host + '/CM-API/NewsApi/getNews',
    getNewsList: host + '/CM-API/NewsApi/getNewsList',
    sealContact: host + '/CM-API/contactApi/sealContact',
    registText: host + '/CM-API/memberApi/registText',
    delContactInfo: host + '/CM-API/contactApi/delContactInfo',
    VerifyCode: host + '/CM-API/memberApi/VerifyCode',
    calPdfHash: host + '/CM-API/contactApi/calPdfHash',
    sealPdfContact: host + '/CM-API/contactApi/sealPdfContact',
    getAdvertList: host + '/CM-API/AdvertApi/getAdvertList', 
    getContactCheckList: host + '/CM-API/contactApi/getContactCheckList',
    checkContact: host + '/CM-API/contactApi/checkContact',
    getCompanyInfo: host + '/CM-API/AdvertApi/getCompanyInfo',
    delTemplate: host + '/CM-API/contactTemplateApi/delTemplate',
    getPageSize: host + '/CM-API/contactTemplateApi/getPageSize',
    delStampInfo: host + '/CM-API/stampApi/delStampInfo',
    cancelOrder: host + '/CM-API/orderApi/cancelOrder',
    aliPay: host + '/CM-API/payApi/aliPay',
    wxPay: host + '/CM-API/payApi/wxPay',
    checkSealPwd: host + '/CM-API/signatureInfoApi/checkSealPwd',
    getStampOrSignatureList: host + '/CM-API/stampApi/getStampOrSignatureList',
    visitorUpload: host + '/CM-API/contactApi/visitorUpload',
    getPaytime: host + '/CM-API/payApi/getPaytime',
    updateTitle: host + '/CM-API/contactApi/updateTitle',
    getMyCertList: host + '/CM-API/signatureApi/getMyCertList',
    getCompanyFormKey: host + '/CM-API/signatureApi/getCompanyFormKey',
    delSignatureInfoById: host + '/CM-API/signatureInfoApi/delSignatureInfoById',
    getUdunPrice: host + '/CM-API/api/udunRecord/getUdunPrice',
    addUkeyApply: host + '/CM-API/api/ukeyApply/addUkeyApply',
    getUkeyList: host + '/CM-API/api/ukeyApply/getList',

    createContactByPdf: host + '/CM-API/contactApi/createContactByPdf',
    updateContactByPdf: host + '/CM-API/contactApi/updateContactByPdf',
    getSealNameList: host + '/CM-API/contactTemplateApi/getSealNameList',

    uptSignatureInfoPwdById: host + '/CM-API/signatureInfoApi/uptSignatureInfoPwdById                  ',

    upload: host + '/CM-API/upload/'
}
export default {
    apiList
}



//////////////////
// WEBPACK FOOTER
// ./static/js/web.js
// module id = null
// module chunks = 